<div class="backgroundColor mine-shaft base">
  <section class="container-fluid backgroundColor mine-shaft base position-relative top-119 py-20">
    <div class="container pt-32">
      <h1 class="text-white h1-size">Acessórios</h1>
    </div>
    <div class="container">
      <div class=" row d-flex justify-content-center">
        <ng-container *ngFor="let item of marcas">
          <a class="card m-1 grayscale clock-expand clock-shadow-card" href="{{link(item)}}">
            <img src="https://{{apiUrl}}/api/marcas/image/{{item.id}}/{{item.media.split(';')[0]}}" class="card-img-top grayscale" alt="...">
          </a>
        </ng-container>
      </div>
    </div>
  </section>
</div>